import React from 'react';
import { 
  Box, 
  Typography, 
  List, 
  ListItem, 
  ListItemAvatar, 
  Avatar, 
  ListItemText, 
  Rating, 
  Divider, 
  CircularProgress 
} from '@mui/material';
import { useGetQuizCommentsQuery, Comments } from "../../Apis/progressApi";



export default function  QuizComments ({ quizId }: { quizId: number | string | undefined })  {
    const numericId = typeof quizId === 'string' ? parseInt(quizId, 10) : quizId;
  const { data: comments, isLoading } = useGetQuizCommentsQuery(numericId as number);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!comments) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography color="text.secondary">No comments or ratings yet for this quiz.</Typography>
      </Box>
    );
  }

  return (
    <List 
  sx={{ 
    width: '100%', 
    bgcolor: 'background.paper', 
    height: 'calc(100vh - 200px)', 
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '0.4em' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,.1)' }
  }}
>
      {comments.map((item: Comments, index: number) => (
        <React.Fragment key={index}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: '#eb3c96' }}>
                {item.fullName.charAt(0).toUpperCase()}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="subtitle2" component="span" fontWeight="bold">
                    {item.fullName}
                  </Typography>
                  <Rating value={item.rate} readOnly size="small" />
                </Box>
              }
              secondary={
                <Typography
                  sx={{ display: 'inline', mt: 1 }}
                  component="span"
                  variant="body2"
                  color="text.primary"
                >
                  {item.comment || "Left a rating without a comment."}
                </Typography>
              }
            />
          </ListItem>
          {index < comments.length - 1 && <Divider variant="inset" component="li" />}
        </React.Fragment>
      ))}
    </List>
  );
};

